import store from 'shared/store';

import {
  post as _post,
} from 'shared/services/ApiService';

export {
  get,
  put,
  upload,
  destroy,
  patch
} from 'shared/services/ApiService';

export const post = async (url, params, headers = {}) => {
  // add current account ID header
  const state = store.getState();
  const { account } = state.portalReducer;

  if (account) {
    headers['CL-Account-ID'] = account.id;
  }

  return await _post(url, params, headers);
}
